/* eslint-disable no-useless-catch */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiget } from '../../service/api';

export const fetchAccountingData = createAsyncThunk('fetchAccountingData', async () => {
    const userid = sessionStorage.getItem('user_id');
    const userRole = sessionStorage.getItem("userRole");
    try {
        const response = await apiget('api/accounting/');
        return response?.data?.result;
    } catch (error) {
        throw error;
    }
});

const accountingSlice = createSlice({
    name: 'accountingDetails',
    initialState: {
        data: [],
        isLoading: false,
        error: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAccountingData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAccountingData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.error = "";
            })
            .addCase(fetchAccountingData.rejected, (state, action) => {
                state.isLoading = false;
                state.data = [];
                state.error = action.error.message;
            });
    },
});

export default accountingSlice.reducer;